<template>
    <div class="data-record data-info">
        <el-row :gutter="10">
            <el-col :span="cols" class="info-parts">
                <span tkey="公司編碼">{{i18n.tkey("lang_companycode")}}:&nbsp;</span>
                <span>{{obj.companycode}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span tkey="公司電郵">{{i18n.tkey("lang_company_email")}}:&nbsp;</span>
                <span>{{obj.email}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span tkey="公司名稱">{{i18n.tkey("lang_company_name")}}:&nbsp;</span>
                <span>{{obj.companyname}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span tkey="公司名稱(英文)">{{i18n.tkey("lang_company_name_eng")}}:&nbsp;</span>
                <span>{{obj.companyname2}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span tkey="地區">{{i18n.tkey("lang_area_text")}}:&nbsp;</span>
                <span>{{regionName}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span tkey="狀態">{{i18n.tkey("lang_state")}}:&nbsp;</span>
                <span>{{stateName}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span tkey="門牌號">{{i18n.tkey("lang_doornum_text")}}:&nbsp;</span>
                <span>{{obj.wa}} - {{obj.siojournal}}</span>
            </el-col>

            <el-col :span="24" class="info-parts">
                <div style="text-align: right">
                    <el-button
                        type="danger"
                        class="auto-mobile-btn"
                        @click="clickBtnFunc('disableShop')"
                        v-show="enableState"
                    >
                        <span tkey="禁用店鋪">{{i18n.tkey("lang_disable_shop")}}</span>
                    </el-button>

                    <el-button
                        type="success"
                        class="auto-mobile-btn"
                        v-show="!enableState"
                        @click="clickBtnFunc('enableShop')"
                    >
                        <span tkey="啟用店鋪">{{i18n.tkey("lang_enable_shop")}}</span>
                    </el-button>

                    <el-button
                        type="primary"
                        class="auto-mobile-btn"
                        @click="clickBtnFunc('moveShop')"
                    >
                        <span tkey="位置移動">{{i18n.tkey("lang_position_move")}}</span>
                    </el-button>

                    <el-button
                        type="primary"
                        class="auto-mobile-btn"
                        @click="clickBtnFunc('staffManage')"
                    >
                        <span tkey="員工管理">{{i18n.tkey("lang_staff_manage")}}</span>
                    </el-button>

                    <el-button
                        type="warning"
                        class="auto-mobile-btn"
                        @click="clickBtnFunc('editAuth')"
                    >
                        <span tkey="編輯權限">{{i18n.tkey("lang_edit_auth")}}</span>
                    </el-button>

                    <el-button
                        type="danger"
                        class="auto-mobile-btn"
                        @click="clickBtnFunc('logoffCompany')"
                    >
                        <span tkey="註銷">{{i18n.tkey("lang_log_off")}}</span>
                    </el-button>
                </div>
            </el-col>

        </el-row>
    </div>
</template>

<script setup>

import {inject, getCurrentInstance, ref, toRef, onBeforeMount, computed} from "vue";
import myUtil from "@/util/util";
import {getCountryObj} from "@/util/countrycode";
import {useUserinfo} from "@/stores/userinfo";

const props = defineProps(["obj"])
const emits = defineEmits(["clickBtn"])

const userInfoRef = toRef(useUserinfo())
const i18n = inject("i18n")
const cols = ref(24)

const regionName = computed(() => {
    let name = "香港"

    if (null != props.obj && null != props.obj.countrycode){
        const countryObj = getCountryObj(props.obj.countrycode)

        name = countryObj[userInfoRef.value.lang]
    }

    return name
})

const stateName = computed(() => {
    let name = i18n.tkey("lang_not_open_shop")

    if (null != props.obj.acccompanycode){
        name = i18n.tkey("lang_normal")
    }

    if (null != props.obj.additionalrecord15 && '0' === props.obj.additionalrecord15.recordno){
        name = i18n.tkey("lang_shop_disable")
    }

    return name
})

const enableState = computed(() => {
    return null != props.obj && null != props.obj.additionalrecord15 && '-1' === props.obj.additionalrecord15.recordno
})

function clickBtnFunc(name){
    emits("clickBtn", name, props.obj)
}

onBeforeMount(() => {
    if (!myUtil.isMobile()){
        cols.value = 12
    }
})

</script>

<style scoped>
    .data-record {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        border: 1px #F0F2F5 solid;
        border-radius: 3px;
    }

    .info-parts {
        margin-bottom: 10px;
    }

    @media screen and (max-width: 520px) {
        .data-info {
            font-size: 12px;
            color: #606266;
        }
    }

    @media screen and (min-width: 520px) {
        .data-info {
            font-size: 14px;
            color: #606266;
        }
    }

    @media screen and (max-width: 520px) {
        .auto-mobile-btn {
            margin-bottom: 10px;
        }
    }

</style>